// ==============================|| APP CONSTANTS  ||============================== //

export const APP_DEFAULT_PATH = "/my-profile";
export const ARTISAN_URL = "https://www.artisanfurniture.net/create-account/";
export const TWO_FACTOR_AUTH_PATH = "/configure-2fa";
export const REGION_VALUES = [
  { name: "india", currency: "&#8377;" },
  { name: "uk", currency: "&#163;" },
  { name: "us", currency: "&#36;" },
  { name: "eu", currency: "&#8364;" },
  { name: "ca", currency: "&#36;" },
];
export const PRODUCT_STATUS = {
  IN_ACTIVE: 0,
  PUBLISHED: 1,
  NEW_ARRIVAL: 2,
  PENDING: 3,
  MODIFIED: 4,
  ARTISAN_ACTIVE: 5,
};
export const SHOP_STATUS = {
  IN_ACTIVE: 0,
  PAYMENT_DONE: 1,
  ADDED: 2,
};
export const USER_ROLE = {
  ADMIN: 0,
  USER: 1,
};
export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const APP_SECRET = process.env.REACT_APP_APP_SECRET;

export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

export const SHOP_PRICE = 1;
export const REGION_INVALID_ERROR = 'Invalid region. Select the correct region or log in to add the store.'
export const REGIONS = [
  "uk", 
  "us", 
  "ca",
  "eu", 
]
export const REGION_CODES_MAP = {
  UK: "uk",
  US: "us",
  CA: "ca",
  EU: "eu"
}